import React from 'react';
import { useAlerts } from './AlertContext';
import Alert from './Alert';
import styles from './AlertContainer.module.css';

const AlertContainer = () => {
    const { alerts, closeAlert, closingAlerts } = useAlerts();

    if (!alerts.length) return null;

    return (
        <div className={styles.alertContainer}>
            {alerts.map(alert => (
                <Alert
                    key={alert.id}
                    type={alert.type}
                    message={alert.message}
                    title={alert.title}
                    icon={alert.icon}
                    onClose={() => closeAlert(alert.id)}
                    closing={closingAlerts[alert.id]}
                />
            ))}
        </div>
    );
};

export default AlertContainer;